import React from "react";
import { Link } from "react-router-dom";

const CSS = `
  *, *::before, *::after { box-sizing: border-box; }

  .bl-root {
    background: #f5f5f7;
    padding: 2rem clamp(1rem, 5vw, 3.5rem) 7rem;
  }

  /* ── SECTION HEADER ── */
  .bl-header {
    max-width: 1240px;
    margin: 0 auto 3.5rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
  }
  .bl-header-left {}
  .bl-header-eyebrow {
    font-size: 9px;
    letter-spacing: 0.26em;
    text-transform: uppercase;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0.6rem;
  }
  .bl-header-eyebrow::before {
    content: '';
    display: block;
    width: 22px; height: 1.5px;
    background: #3b82f6;
  }
  .bl-header-title {
    font-size: clamp(2rem, 4.5vw, 3.4rem);
    font-weight: 300;
    color: #1d1d1f;
    line-height: 0.96;
    letter-spacing: -0.03em;
  }
  .bl-header-title em { font-style: italic; color: #2563eb; }
  .bl-header-count {
    font-size: 10px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(29,29,31,0.28);
    padding-bottom: 4px;
  }

  /* ── STAGE: featured + stack ── */
  .bl-stage {
    max-width: 1240px;
    margin: 0 auto 16px;
    display: grid;
    grid-template-columns: 1fr 380px;
    gap: 16px;
    height: 540px;
  }
  @media (max-width: 900px) {
    .bl-stage { grid-template-columns: 1fr; height: auto; }
    .bl-stack { display: none; }
  }

  /* featured hero card */
  .bl-featured {
    position: relative;
    border-radius: 18px;
    overflow: hidden;
    background: #1d1d1f;
    cursor: pointer;
    height: 100%;
  }
  .bl-featured img {
    width: 100%; height: 100%;
    object-fit: cover;
    filter: brightness(0.50) saturate(0.85);
    transition: transform 7s ease, filter 0.4s ease;
    transform: scale(1.04);
  }
  .bl-featured:hover img {
    transform: scale(1);
    filter: brightness(0.40) saturate(0.9);
  }
  .bl-featured-vignette {
    position: absolute; inset: 0;
    background:
      linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.18) 52%, transparent 80%),
      linear-gradient(to right, rgba(0,0,0,0.28) 0%, transparent 60%);
    pointer-events: none;
  }
  .bl-featured-body {
    position: absolute; bottom: 0; left: 0; right: 0;
    padding: 2rem 2.2rem;
  }
  .bl-featured-kicker {
    font-size: 9px; letter-spacing: 0.22em; text-transform: uppercase;
    color: #60a5fa; margin-bottom: 0.65rem; display: block;
  }
  .bl-featured-title {
    font-size: clamp(1.5rem, 2.8vw, 2.2rem);
    font-weight: 400;
    color: #fff; line-height: 1.12;
    letter-spacing: -0.025em;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0.6rem;
    transition: color 0.2s;
  }
  .bl-featured:hover .bl-featured-title { color: #93c5fd; }
  .bl-featured-excerpt {
    font-size: 0.78rem; color: rgba(255,255,255,0.42);
    line-height: 1.65;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 1.1rem;
  }
  .bl-featured-foot {
    display: flex; align-items: center; justify-content: space-between;
  }
  .bl-featured-date {
    font-size: 9px; letter-spacing: 0.10em; text-transform: uppercase;
    color: rgba(255,255,255,0.28);
  }
  .bl-featured-link {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 9px; letter-spacing: 0.16em; text-transform: uppercase;
    color: #3b82f6; text-decoration: none;
    transition: gap 0.2s ease;
  }
  .bl-featured:hover .bl-featured-link { gap: 9px; }
  .bl-featured-link svg { width: 11px; height: 11px; }
  .bl-featured-num {
    position: absolute; top: 1.2rem; right: 1.4rem;
    font-size: 9px; letter-spacing: 0.1em;
    color: rgba(255,255,255,0.18);
  }

  /* right stack of 2 */
  .bl-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
  }
  .bl-stack-card {
    flex: 1;
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    background: #1d1d1f;
    cursor: pointer;
    min-height: 0;
  }
  .bl-stack-card img {
    width: 100%; height: 100%;
    object-fit: cover;
    filter: brightness(0.50) saturate(0.80);
    transition: transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94), filter 0.3s ease;
    transform: scale(1.03);
  }
  .bl-stack-card:hover img {
    transform: scale(1);
    filter: brightness(0.38) saturate(0.85);
  }
  .bl-stack-vignette {
    position: absolute; inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.88) 0%, transparent 60%);
    pointer-events: none;
  }
  .bl-stack-body {
    position: absolute; bottom: 0; left: 0; right: 0;
    padding: 1.1rem 1.3rem;
  }
  .bl-stack-kicker {
    font-size: 8px; letter-spacing: 0.2em; text-transform: uppercase;
    color: #60a5fa; margin-bottom: 0.3rem; display: block;
  }
  .bl-stack-title {
    font-size: 0.92rem; font-weight: 500;
    color: #fff; line-height: 1.25;
    letter-spacing: -0.01em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.2s;
  }
  .bl-stack-card:hover .bl-stack-title { color: #93c5fd; }
  .bl-stack-date {
    font-size: 8px; letter-spacing: 0.09em; text-transform: uppercase;
    color: rgba(255,255,255,0.24); margin-top: 0.45rem;
    display: flex; align-items: center; justify-content: space-between;
  }
  .bl-stack-link {
    color: #3b82f6; text-decoration: none;
    font-size: 8px; letter-spacing: 0.12em; text-transform: uppercase;
    display: inline-flex; align-items: center; gap: 4px;
    transition: gap 0.2s;
  }
  .bl-stack-card:hover .bl-stack-link { gap: 7px; }
  .bl-stack-link svg { width: 10px; height: 10px; }

  /* ── HORIZONTAL LIST ROWS ── */
  .bl-list {
    max-width: 1240px;
    margin: 0 auto;
  }
  .bl-list-item {
    display: grid;
    grid-template-columns: 240px 1fr auto;
    align-items: center;
    gap: 1.5rem;
    border-bottom: 0.5px solid rgba(29,29,31,0.09);
    padding: 1.1rem 0;
    cursor: pointer;
    transition: background 0.2s;
    text-decoration: none;
    color: inherit;
  }
  .bl-list-item:first-child { border-top: 0.5px solid rgba(29,29,31,0.09); }
  .bl-list-item:hover { background: rgba(59,130,246,0.025); }
  .bl-list-item:hover .bl-list-title { color: #2563eb; }
  .bl-list-item:hover .bl-list-img img { transform: scale(1.07); filter: brightness(0.78); }

  @media (max-width: 680px) {
    .bl-list-item { grid-template-columns: 120px 1fr; }
    .bl-list-arrow { display: none; }
  }

  .bl-list-img {
    width: 240px; height: 68px;
    border-radius: 8px; overflow: hidden;
    background: #e5e5ea; flex-shrink: 0;
  }
  @media (max-width: 680px) { .bl-list-img { width: 120px; } }
  .bl-list-img img {
    width: 100%; height: 100%; object-fit: cover;
    filter: brightness(0.92) saturate(0.85);
    transition: transform 0.55s cubic-bezier(0.25,0.46,0.45,0.94), filter 0.3s ease;
  }

  .bl-list-info { min-width: 0; }
  .bl-list-title {
    font-size: clamp(0.88rem, 1.4vw, 1.05rem);
    font-weight: 500;
    color: #1d1d1f;
    letter-spacing: -0.01em;
    line-height: 1.25;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.2s ease;
  }
  .bl-list-excerpt {
    font-size: 0.75rem;
    color: rgba(29,29,31,0.38);
    margin-top: 0.25rem;
    line-height: 1.55;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .bl-list-meta {
    display: flex; align-items: center; gap: 0.6rem;
    margin-top: 0.45rem;
  }
  .bl-list-date {
    font-size: 9px; letter-spacing: 0.10em;
    text-transform: uppercase; color: rgba(29,29,31,0.30);
  }

  .bl-list-arrow {
    display: flex; align-items: center; gap: 5px;
    font-size: 9px; letter-spacing: 0.14em;
    text-transform: uppercase; color: #3b82f6;
    flex-shrink: 0;
    transition: gap 0.2s ease;
  }
  .bl-list-item:hover .bl-list-arrow { gap: 9px; }
  .bl-list-arrow svg { width: 11px; height: 11px; }

  /* list section label */
  .bl-list-head {
    max-width: 1240px;
    margin: 3rem auto 1.25rem;
    display: flex; align-items: center; gap: 1rem;
  }
  .bl-list-head-label {
    font-size: 9px; letter-spacing: 0.2em; text-transform: uppercase;
    color: rgba(29,29,31,0.30); white-space: nowrap;
  }
  .bl-list-head-line {
    flex: 1; height: 0.5px; background: rgba(29,29,31,0.09);
  }
`;

const Arrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>
  </svg>
);

const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });

const Blogs = ({ blogs }) => {
  if (!blogs || blogs.length === 0) return null;

  const [featured, second, third, ...rest] = blogs;

  return (
    <>
      <style>{CSS}</style>
      <div className="bl-root">

        <div className="bl-header">
          <div className="bl-header-left">
            <p className="bl-header-eyebrow">BCS Updates</p>
            <h2 className="bl-header-title">Latest <em>Updates</em></h2>
          </div>
          <span className="bl-header-count">{blogs.length} Posts</span>
        </div>

        <div className="bl-stage">
          <Link to={`/blog/${featured.id}`} className="bl-featured" style={{ textDecoration: "none" }}>
            {featured.thumbnail && <img src={featured.thumbnail} alt={featured.title} />}
            <div className="bl-featured-vignette" />
            <span className="bl-featured-num">01 / {String(blogs.length).padStart(2, "0")}</span>
            <div className="bl-featured-body">
              <span className="bl-featured-kicker">Featured</span>
              <p className="bl-featured-title">{featured.title}</p>
              <p className="bl-featured-excerpt">{featured.content}</p>
              <div className="bl-featured-foot">
                <span className="bl-featured-date">{fmtDate(featured.createdAt)}</span>
                <span className="bl-featured-link">Read article <Arrow /></span>
              </div>
            </div>
          </Link>

          <div className="bl-stack">
            {[second, third].filter(Boolean).map((blog) => (
              <Link key={blog.id} to={`/blog/${blog.id}`} className="bl-stack-card" style={{ textDecoration: "none" }}>
                {blog.thumbnail && <img src={blog.thumbnail} alt={blog.title} />}
                <div className="bl-stack-vignette" />
                <div className="bl-stack-body">
                  <span className="bl-stack-kicker">Article</span>
                  <p className="bl-stack-title">{blog.title}</p>
                  <div className="bl-stack-date">
                    <span>{fmtDate(blog.createdAt)}</span>
                    <span className="bl-stack-link">Read <Arrow /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {rest.length > 0 && (
          <>
            <div className="bl-list-head">
              <span className="bl-list-head-label">More Articles</span>
              <div className="bl-list-head-line" />
              <span className="bl-list-head-label">{rest.length} Posts</span>
            </div>
            <div className="bl-list">
              {rest.map((blog) => (
                <Link key={blog.id} to={`/blog/${blog.id}`} className="bl-list-item">
                  <div className="bl-list-img">
                    {blog.thumbnail && <img src={blog.thumbnail} alt={blog.title} />}
                  </div>
                  <div className="bl-list-info">
                    <p className="bl-list-title">{blog.title}</p>
                    <p className="bl-list-excerpt">{blog.content}</p>
                    <div className="bl-list-meta">
                      <span className="bl-list-date">{fmtDate(blog.createdAt)}</span>
                    </div>
                  </div>
                  <span className="bl-list-arrow">Read <Arrow /></span>
                </Link>
              ))}
            </div>
          </>
        )}

      </div>
    </>
  );
};

export default Blogs;